import Reveal from './Reveal';
import StudioBuildPhase from './StudioBuildPhase';
import { buildPhases } from '../data/studioBuildLog';

export default function StudioBuildSection() {
  return (
    <section id="studio-build" className="bg-[#f4f3f1] py-20 md:py-28 border-y border-gray-200">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <Reveal>
            <div className="mb-14 md:mb-20">
              <p className="eyebrow text-teal-600 text-sm md:text-base mb-4">Making of Studio</p>
              <h2 className="font-mincho text-3xl md:text-5xl text-gray-900 mb-6 text-balance">
                スタジオができるまで
              </h2>
              <div className="w-20 h-[3px] bg-teal-500 rounded-full mb-6" />
              <p className="max-w-2xl text-gray-600 leading-relaxed text-sm md:text-base text-pretty">
                まだ何もない部屋に、壁が立ち、配線が走り、音のための空間が生まれていく。
                その一つひとつの工程に、この場所からこれから鳴る音への期待を込めて。
                完成までの記録を、写真とともに残していきます。
              </p>
            </div>
          </Reveal>

          <div className="space-y-16 md:space-y-24">
            {buildPhases.map((phase) => (
              <StudioBuildPhase key={phase.id} phase={phase} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
